import { render, staticRenderFns } from "./TodoSalesOrder.vue?vue&type=template&id=31e4e91c&scoped=true&"
import script from "./TodoSalesOrder.vue?vue&type=script&lang=js&"
export * from "./TodoSalesOrder.vue?vue&type=script&lang=js&"
import style0 from "./TodoSalesOrder.vue?vue&type=style&index=0&id=31e4e91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e4e91c",
  null
  
)

export default component.exports